<div class="ph-swiper">
  <swiper [config]="config" #swiperEl>
    <ng-content></ng-content>
  </swiper>
  <div
    class="swiper-button swiper-button-prev-unique"
    *ngIf="config.navigation && arrowsType === 'homepage'"
  >
    <img src="assets/img/icons/slider-prev.svg" [alt]="'GLOBAL.prev' | translate" />
  </div>
  <div
    class="swiper-button swiper-button-next-unique"
    *ngIf="config.navigation && arrowsType === 'homepage'"
  >
    <img src="assets/img/icons/slider-next.svg" [alt]="'GLOBAL.next' | translate" />
  </div>
  <div
    class="swiper-button swiper-button-prev-unique-2"
    *ngIf="config.navigation && arrowsType === 'our-planet'"
  >
    <img src="assets/img/icons/slider-prev.svg" [alt]="'GLOBAL.prev' | translate" />
  </div>
  <div
    class="swiper-button swiper-button-next-unique-2"
    *ngIf="config.navigation && arrowsType === 'our-planet'"
  >
    <img src="assets/img/icons/slider-next.svg" [alt]="'GLOBAL.next' | translate" />
  </div>
  <div
    class="swiper-button swiper-button-prev-unique-3"
    *ngIf="config.navigation && arrowsType === 'homepage-events'"
  >
    <img src="assets/img/icons/slider-prev.svg" [alt]="'GLOBAL.prev' | translate" />
  </div>
  <div
    class="swiper-button swiper-button-next-unique-3"
    *ngIf="config.navigation && arrowsType === 'homepage-events'"
  >
    <img src="assets/img/icons/slider-next.svg" [alt]="'GLOBAL.next' | translate" />
  </div>
  <div
    class="swiper-button swiper-button-prev-unique-4"
    *ngIf="config.navigation && arrowsType === 'events'"
  >
    <img src="assets/img/icons/slider-prev.svg" [alt]="'GLOBAL.prev' | translate" />
  </div>
  <div
    class="swiper-button swiper-button-next-unique-4"
    *ngIf="config.navigation && arrowsType === 'events'"
  >
    <img src="assets/img/icons/slider-next.svg" [alt]="'GLOBAL.next' | translate" />
  </div>
</div>
